import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Order.css";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("userInfo"));
        if (!storedUser || !storedUser.token) {
          setError("Please login to view your orders.");
          setLoading(false);
          return;
        }

        const config = {
          headers: {
            Authorization: `Bearer ${storedUser.token}`,
          },
        };

        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_SERVER}/api/orders/myorders`,
          config
        );

        setOrders(data);
        console.log("data", data);
        
      } catch (err) {
        console.error("Error fetching orders:", err);
        setError("Failed to load orders.");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  if (loading) return <p>Loading orders...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="orders-container">
      <h2>My Orders</h2>
      {orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        <table className="orders-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Date</th>
              <th>Method</th>
              <th>payment</th>
              <th>orderStatus</th>
              <th>Amount</th>
              <th>view</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order._id}>
                <td>{order._id}</td>
                <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                <td>{order.paymentMethod}</td>
                <td>{order.paymentStatus}</td>
                <td>{order.orderStatus}</td>
                <td> ${order.totalAmount}</td>
                <td> ...</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Orders;
